import { render, staticRenderFns } from "./ImageAmplify.vue?vue&type=template&id=0a0e704c&"
import script from "./ImageAmplify.vue?vue&type=script&lang=js&"
export * from "./ImageAmplify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports